<div class="container-fluid pt-3">
  <app-influencer-add
    [projectId]="projectId"
    [hideClass]="true" [influencerType]="audienceType" [isModal]="true"
    (closeModal)="closeModal()"></app-influencer-add>
</div>
